import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeinfo'
})
export class TimeinfoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if( typeof value === 'string'){
      value = Date.parse(value);
    }
    return this.getFormatTime(value);
  }

  // 获取当前时间戳
  getUnix() {
    const date = new Date();
    return date.getTime();
  }
  // 获取今天0点0分0秒的时间戳
  getTodayUnix() {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date.getTime();
  }
  // 获取今年1月1日0点0分0秒的时间戳
  getYearUnix() {
    const date = new Date();
    date.setMonth(0);
    date.setDate(1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date.getTime();
  }
  // 获取标准年月日
  getLastDate(time) {
    const date = new Date(time);
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return date.getFullYear() + '-' + month + '-' + day;
  }
  // 时间转化
  getFormatTime(timestamp) {
    const now = this.getUnix();
    const today = this.getTodayUnix();
    // const year = this.getYearUnix();
    const timer = (now - timestamp) / 1000; // 转换为秒级时间戳
    let tip = '';
    if (timer <= 0) {
      tip = '刚刚';
    } else if (Math.floor(timer / 60) <= 0) {
      tip = '刚刚';
    } else if (timer <= 3600) {
      tip = Math.floor(timer / 60) + '分钟前';
    } else if (timer >= 3600 && timer / 3600 <= 23) {
      tip = Math.floor(timer / 3600) + '小时前';
    } else if (timer / 86400 >= 1 && timer / 86400 <= 31) {
      tip = Math.floor(timer / 86400) + '天前';
    } else {
      tip = this.getLastDate(timestamp);
    }
    return tip;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/pipes/timeinfo.pipe.ts